import logo2013 from "../../assets/img/historicEvents/LogoPayback/2013.png";
import logo2014 from "../../assets/img/historicEvents/LogoPayback/2014.png";
import logo2015 from "../../assets/img/historicEvents/LogoPayback/2015.png";
import logo2016_2017 from "../../assets/img/historicEvents/LogoPayback/2016-2017.png";
import logo2020 from "../../assets/img/historicEvents/LogoPayback/2020.png";
import logo2023 from "../../assets/img/historicEvents/LogoPayback/2023.png";

export const paybackDetail = {
  payback: {
    id: "payback",
    title: "Payback",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "payback",
        items: [
          {
            id: "payback-2013",
            title: "Payback",
            description: "2013",
            imgUrl: logo2013,
          },
          {
            id: "payback-2014",
            title: "Payback",
            description: "Payback… it's what's Best for Business! 2014",
            imgUrl: logo2014,
          },
          {
            id: "payback-2015",
            title: "Payback",
            description: "2015",
            imgUrl: logo2015,
          },
          {
            id: "payback-2016",
            title: "Payback",
            description: "The first pay-per-view of a New Era 2016",
            imgUrl: logo2016_2017,
          },
          {
            id: "payback-2017",
            title: "Payback",
            description: "2017",
            imgUrl: logo2016_2017,
          },
          {
            id: "payback-2020",
            title: "Payback",
            description: "2020",
            imgUrl: logo2020,
          },
          {
            id: "payback-2023",
            title: "Payback",
            description: "2023",
            imgUrl: logo2023,
          },
        ],
      },
    ],
  },
};
